import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Search } from "lucide-react";
import { api } from "@/lib/api";
import { PageTitle, Card, Field, inputCls, GoldButton } from "@/admin/ui";

const FIELDS = [
  ["title", "Título (title tag)", false],
  ["description", "Meta Descrição", true],
  ["keywords", "Palavras-chave (keywords)", true],
  ["og_image", "Imagem OG (URL)", false],
  ["canonical", "URL Canônica", false],
  ["robots", "Robots", false],
  ["google_verification", "Google Site Verification", false],
];

export const SeoManager = () => {
  const [seo, setSeo] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/admin/seo").then(({ data }) => setSeo(data)); }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { key, _id, ...payload } = seo;
      await api.put("/admin/seo", payload);
      toast.success("SEO salvo");
    } catch { toast.error("Erro ao salvar"); } finally { setSaving(false); }
  };

  if (!seo) return <div className="text-white/40">Carregando...</div>;

  return (
    <div data-testid="admin-seo">
      <PageTitle title="SEO" subtitle="Otimização para mecanismos de busca"
        action={<GoldButton onClick={save} disabled={saving} data-testid="seo-save"><Save className="w-4 h-4 inline mr-1" /> {saving ? "Salvando..." : "Salvar"}</GoldButton>} />
      <div className="grid lg:grid-cols-[1.4fr_1fr] gap-6">
        <Card>
          <div className="space-y-4">
            {FIELDS.map(([k, label, area]) => (
              <Field key={k} label={label}>
                {area ? (
                  <textarea value={seo[k] ?? ""} onChange={(e) => setSeo({ ...seo, [k]: e.target.value })} rows={2} className={inputCls + " resize-y"} data-testid={`seo-${k}`} />
                ) : (
                  <input value={seo[k] ?? ""} onChange={(e) => setSeo({ ...seo, [k]: e.target.value })} className={inputCls} data-testid={`seo-${k}`} />
                )}
              </Field>
            ))}
          </div>
        </Card>

        <Card>
          <h3 className="font-display font-bold text-white mb-4 flex items-center gap-2"><Search className="w-4 h-4 text-[#F5C542]" /> Prévia no Google</h3>
          <div className="p-4 rounded-xl bg-white/[0.02] border border-white/[0.06]">
            <div className="text-[#8ab4f8] text-lg leading-tight truncate">{seo.title || "Título do site"}</div>
            <div className="text-[#00FF41]/70 text-xs mt-1 truncate">{seo.canonical || "https://grupomanga.com"}</div>
            <div className="text-white/60 text-sm mt-2 line-clamp-2">{seo.description || "Descrição do site aparecerá aqui."}</div>
          </div>
          <p className="text-[11px] text-white/30 mt-4">As tags são aplicadas dinamicamente no site público.</p>
        </Card>
      </div>
    </div>
  );
};
